<template>
  <div class="relative">
    <datepicker
                format="dd.MM.yyyy"
                v-model="model"
                inBody
                typeable
                :disabled="disabled"
                :disabled-dates="disabledDates"
                :class="{'has-error': hasErrors}"
    />
    <transition name="fade">
      <div v-if="hasErrors" class="validation-input-error">
        {{firstErrorMessage}}
      </div>
    </transition>
  </div>
</template>

<script>
  import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
  export default {
    name: "ActDatepicker",
    mixins: [singleErrorExtractorMixin],
    props: {
      classInput: {},
      disabled: {
        type: Boolean,
        default: false
      },
      value: {},
      min: {
        default: null
      },
      max: {
        default: null
      }
    },
    computed: {
      model : {
        get () {
          return this.value === null ? null : this.$parseDateFromString(this.value.split('T')[0]);
        },
        set (v) {
          let value = v === null ? null : this.$options.filters.moment(v, 'YYYY-MM-DD');
          this.$emit('input', value);
        }
      },
      disabledDates(){
        let range = {};

        if(this.min){
          range.to = this.$moment(this.$parseDateFromString(this.min)).subtract(1, 'day').toDate();
        }

        if(this.max){
          range.from = this.$moment(this.$parseDateFromString(this.max)).subtract(1, 'day').toDate();
        }

        return range;
      }
    }
  }
</script>
